import React, { Component, PropTypes } from 'react'

export class TriColumn extends Component {
  render() {
    return (
      <section>
        <div className="container">
          <div className="section__head--noPara">
            <h2>Frequently Asked Questions</h2>
          </div>
          <div className="section__body">
            <div className="row">
              <div className="column--third">
                <div className="card">
                  <div className="meta left">
                    <h4>Is my school subsidizing my pass?</h4>
                    <p>
                      We work directly with schools to streamline this process for players so your coach will
                      be the best person to tell you how to get a Season Pass.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--third">
                <div className="card">
                  <div className="meta left">
                    <h4>Do I bring my own computer?</h4>
                    <p>
                      If you prefer, but it’s not required. We’ll work with your school’s IT team to see if
                      your school has equipment that meets our system requirements.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--third">
                <div className="card">
                  <div className="meta left">
                    <h4>What do I need to play?</h4>
                    <p>
                      You need a computer that passes our benchmark test, a mouse, a keyboard, and a love for
                      the game. Headsets are recommended, but not required.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--third">
                <div className="card">
                  <div className="meta left">
                    <h4>Can I play all year?</h4>
                    <p>
                      Yes! There are two seasons per school year, which means you can compete in the fall and
                      in the spring. Since season passes are good for one season, you’ll just need two season
                      passes to do so. Game on.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--third">
                <div className="card">
                  <div className="meta left">
                    <h4>What if I’ve never played on a team?</h4>
                    <p>
                      Now is always a good time to start! Ask your coach about when the next practice is and
                      see how you can get started. There are no cuts, so newbies are welcome! Chances are you
                      won’t be the only one.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--third">
                <div className="card">
                  <div className="meta left">
                    <h4>What are my payment options?</h4>
                    <p>
                      Payments can be made by credit card, ACH, wire, or check. We also provide schools with
                      quotes and invoices with P.O. numbers. Contact us at accounting@playvs.com for more
                      information.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default TriColumn



// WEBPACK FOOTER //
// ./src/common/ui/components/triColumn__FAQ.js